export default {
    SET_DISCOUNT: (state, value) => {
        state.discount = value;
    },
    SET_DISCOUNTS: (state, value) => {
        state.discounts = value;
    }
};